import React from 'react';

const VideoPreview = ({ className, children, ...props }: React.ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <button type="button" {...props} className={`rounded-md text-white w-16 h-12 grid place-items-center text-2xl mr-1 focus:outline-none ${className}`}>
      {children}
    </button>
  );
};

export default VideoPreview;
